import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Dashbaord } from './dashbaord';
import { HttpService } from '@core/services';
import { catchError, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class OpportunityService {
  constructor(
    private readonly _httpClient: HttpService,
  ) { }

  getOpportunity(): Observable<Dashbaord[]> {
    return this._httpClient.post('rest/v1/rpc/get_user_opportunity_dashboard', {}, true).pipe(
      catchError(() => this._httpClient.get('rest/v1/opportunity?select=*', undefined, true))
    );
  }

  getMappedOpportunityIds(): Observable<string[]> {
    return this._httpClient
      .get('rest/v1/crm_record_mappings?select=opportunity_id', undefined, true)
      .pipe(
        map((response: Array<{ opportunity_id?: string | null }> | null | undefined) => {
          const rows = Array.isArray(response) ? response : [];
          return rows
            .map(row => row?.opportunity_id?.toString().trim() ?? '')
            .filter(opportunityId => opportunityId.length > 0);
        })
      );
  }
}
